import { fetchUrl } from './api';

export default function fetcher(url) {
  return fetchUrl({ method: 'GET', url });
}
